import type { Moment, MomentInput } from 'moment'

import jstz from 'jstz'
import 'moment-timezone'
import 'moment-strftime'

import { SfTime } from '@app/adapters/time'

const datetimeToMoment = (
  datetime: MomentInput,
  shouldUseLocalTimezone: boolean
): Moment => {
  const timezone = jstz.determine()

  const originalMoment = shouldUseLocalTimezone
    ? SfTime(datetime).tz(timezone.name())
    : SfTime(datetime)

  return originalMoment
}

export default datetimeToMoment
